/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import NoticeBanner from 'common/components/notice-banner/notice-banner';
// eslint-disable-next-line no-restricted-imports
import ClientConfig from 'common/debug/client-config';
// eslint-disable-next-line no-restricted-imports
import { localizeCount } from 'common/lib/util/i18n';
import * as React from 'react';
import styles from './closed-boards-dialog.less';

const isDesktop = ClientConfig.get('appId') === 'desktop';

interface FreeTeamsOutOfSpaceBannerProps {
  freeTeamCount: number;
  onTeamCountClick: React.MouseEventHandler;
}

const FreeTeamsOutOfSpaceBanner = (props: FreeTeamsOutOfSpaceBannerProps) => {
  const xFreeTeams = (
    <a
      key={props.freeTeamCount}
      className={styles.bannerLink}
      onClick={props.onTeamCountClick}
      role="link"
    >
      {localizeCount('free-teams', props.freeTeamCount)}
    </a>
  );
  const message = isDesktop
    ? localizeCount('free teams out of space desktop', props.freeTeamCount, {
        xFreeTeams,
      })
    : localizeCount('free teams out of space', props.freeTeamCount, {
        xFreeTeams,
      });

  return <NoticeBanner inline>{message}</NoticeBanner>;
};

export default FreeTeamsOutOfSpaceBanner;



// WEBPACK FOOTER //
// ./app/common/components/closed-boards-dialog/free-teams-out-of-space-banner.tsx